import { Box, Flex, Logo, theme } from '@xometry/xometry_loft';
import React from 'react';
import { WORK_ORIGIN } from '../../../../config';

export interface Props {
  marketingData: any;
}

const MarketingPanel = (props: Props) => {
  const { marketingData } = props;
  return (
    <Box
      width="480px"
      display={['none', 'none', 'none', 'initial']}
      backgroundColor={theme.colors.darkBlues[5]}
      zIndex={0}
      overflowY="auto"
    >
      <Box marginBottom="37px">
        <a href={WORK_ORIGIN}>
          <Logo
            logoType="fullLogo"
            height="38px"
            marginLeft="36px"
            marginTop="36px"
            alt="Xometry Logo"
          />
        </a>
      </Box>
      {marketingData && (
        <Box padding="0px 48px">
          <Box textAlign="center" marginBottom="36px">
            <Box
              color={theme.colors.darkBlues[100]}
              fontSize="28px"
              fontWeight={theme.fontWeights.semibold}
              lineHeight="36px"
              marginBottom="8px"
            >
              {marketingData.title[0].text}
            </Box>
            <Box fontSize={theme.fontSizes[0]}>
              {marketingData.subtext[0].text}{' '}
              {typeof marketingData.subtext[1] !== 'undefined' && (
                <a href={marketingData.subtext[1].spans[0].data.url}>
                  {marketingData.subtext[1].text}
                </a>
              )}
            </Box>
          </Box>
          <Box>
            <Flex alignItems="center" marginBottom="44px">
              <Box marginRight="20px" marginTop="8px">
                <img
                  src={marketingData.benefit_image_one.url}
                  alt={marketingData.benefit_image_one.alt}
                />
              </Box>
              <Box
                fontSize={theme.fontSizes[3]}
                lineHeight="28px"
                width="256px"
              >
                {marketingData.benefit_text_one[0].text}
              </Box>
            </Flex>
            <Flex alignItems="center" marginBottom="44px">
              <Box marginRight="20px" marginTop="8px">
                <img
                  src={marketingData.benefit_image_two.url}
                  alt={marketingData.benefit_image_two.alt}
                />
              </Box>
              <Box
                fontSize={theme.fontSizes[3]}
                lineHeight="28px"
                width="256px"
              >
                {marketingData.benefit_text_two[0].text}
              </Box>
            </Flex>
            <Flex alignItems="center" marginBottom="44px">
              <Box marginRight="20px" marginTop="8px">
                <img
                  src={marketingData.benefit_image_three.url}
                  alt={marketingData.benefit_image_three.alt}
                />
              </Box>
              <Box
                fontSize={theme.fontSizes[3]}
                lineHeight="28px"
                width="256px"
              >
                {marketingData.benefit_text_three[0].text}
              </Box>
            </Flex>
          </Box>
        </Box>
      )}
      {marketingData && (
        <Box position="fixed" bottom="-5px" zIndex={-1}>
          <img
            src={marketingData.splash_image.url}
            alt={marketingData.splash_image.alt}
          />
        </Box>
      )}
    </Box>
  );
};

export default MarketingPanel;
